module.exports = __webpack_public_path__ + "img/export_files_icon.15fa32dc.svg";